/** While an email is being sent, or just after a Send or a cancel, the pages poll this often. */
export const FAST_POLL_MS = 3_000;
/** While emails only wait in the queue (the next wave can be minutes or days away). */
export const QUEUED_POLL_MS = 15_000;
/** Nothing on its way: the list still picks up replies and the assistant's drafts. */
export const SETTLED_POLL_MS = 30_000;
/** How long the fast poll lasts after a Send or a cancel succeeded: the first wave goes out within it. */
export const FAST_AFTER_ACTION_MS = 90_000;

let fastUntil = 0;

/** Called when a Send or a cancel succeeded: every prospects query polls fast for a while. */
export function pollFastAfterAction(now = Date.now()): void {
  fastUntil = now + FAST_AFTER_ACTION_MS;
}

/** Tests only: forget the last action. */
export function resetQueuePolling(): void {
  fastUntil = 0;
}

export type QueueActivity = { sending: boolean; queued: boolean };

type EmailState = { state: string } | null | undefined;

export const emailActivity = (emails: readonly EmailState[]): QueueActivity => ({
  sending: emails.some((email) => email?.state === 'sending'),
  queued: emails.some((email) => email?.state === 'queued')
});

/** 3 s while something is sending or right after an action, 15 s while emails only wait, 30 s otherwise. */
export function queuePollInterval(activity: QueueActivity, now = Date.now()): number {
  if (activity.sending || now < fastUntil) return FAST_POLL_MS;
  return activity.queued ? QUEUED_POLL_MS : SETTLED_POLL_MS;
}

/** The dialog polls only while its newest email (the API lists them newest first) is on its way. */
export function detailPollInterval(emails: readonly EmailState[] | undefined, now = Date.now()): number | false {
  const activity = emailActivity(emails?.slice(0, 1) ?? []);
  return activity.sending || activity.queued ? queuePollInterval(activity, now) : false;
}
